var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6389 7.99997V7.37497C15.6389 6.95831 15.3611 6.68053 14.9444 6.68053C14.5278 6.68053 14.25 6.95831 14.25 7.37497V7.99997C14.25 11.4722 11.4722 14.25 7.99997 14.25C4.52775 14.25 1.74997 11.4722 1.74997 7.99997C1.74997 4.52775 4.52775 1.74997 7.99997 1.74997C8.90275 1.74997 9.73608 1.95831 10.5694 2.30553C10.9166 2.44442 11.3333 2.30553 11.4722 1.95831C11.6111 1.61108 11.4722 1.19442 11.125 1.05553C10.1528 0.569417 9.04164 0.361084 7.99997 0.361084C3.76386 0.361084 0.361084 3.76386 0.361084 7.99997C0.361084 12.2361 3.76386 15.6389 7.99997 15.6389C12.2361 15.6389 15.6389 12.2361 15.6389 7.99997ZM15.1528 1.26391C15.4306 0.986128 15.8473 0.986128 16.1251 1.26391C16.4028 1.54168 16.4028 1.95835 16.1251 2.23613L8.48618 9.87502C8.34729 10.0139 8.13896 10.0834 8.00007 10.0834C7.86118 10.0834 7.65285 10.0139 7.51396 9.87502L5.43062 7.79168C5.15285 7.51391 5.15285 7.09724 5.43062 6.81946C5.7084 6.54168 6.12507 6.54168 6.40285 6.81946L8.00007 8.41668L15.1528 1.26391Z",
    fill: "#7EDE86"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.34a93d26cd2921cfe352ccb6093613ae.svg";
export { ForwardRef as ReactComponent };